import { INIT_CLIENTS, INIT_EVENTS, DEFAULT_TARIF } from "../../constants";
import { migrateAllClients } from "../../utils/clientProductMigration";
import {
  mergePersistedClientsWithInit,
  mergePersistedEventsWithInit,
} from "../../utils/mergePersistedWithInit";
import { normalizeLegacyNoShowClients, normalizeLegacyNoShowEvents } from "../../utils/normalizeLegacyNoShow";

/**
 * Navigation, démo, état UI global.
 */
export function createUiSlice(set, get) {
  return {
    view: "dashboard",
    booting: true,
    loggedIn: false,
    settingsDirty: false,
    regenTrigger: 0,
    onboarded: true,
    splashSeen: false,
    demoMode: true,
    _realData: null,
    _standbyConflicts: null,
    /** @type {{ tab: string, scrollCharges?: boolean } | null} */
    settingsNavIntent: null,

    /** Toast global — un seul à la fois, auto-dismiss après 3s. */
    toastMessage: null,
    toastType: "success", // "success" | "error" | "info"
    showToast: (message, type = "success") => {
      set({ toastMessage: message, toastType: type });
      setTimeout(() => {
        if (get().toastMessage === message) set({ toastMessage: null });
      }, 3000);
    },

    login: () => set({ loggedIn: true }),
    setView: (v) => set({ view: v, selectedClient: null }),
    setViewRaw: (v) => set({ view: v }),
    setOnboarded: (v) => set({ onboarded: v }),
    setSplashSeen: (v) => set({ splashSeen: v }),
    setSettingsDirty: (v) => set({ settingsDirty: v }),
    setSettingsNavIntent: (intent) => set({ settingsNavIntent: intent }),
    triggerRegen: () => set((s) => ({ regenTrigger: s.regenTrigger + 1 })),

    resetDemoData: () => {
      const s = get();
      const t = s.sessionTarif || DEFAULT_TARIF;
      const freshClients = migrateAllClients(
        normalizeLegacyNoShowClients([...INIT_CLIENTS.map((c) => ({ ...c, sessions: [...(c.sessions || [])] }))]),
        s.products,
        t,
      );
      const freshEvents = normalizeLegacyNoShowEvents(INIT_EVENTS.map((e) => ({ ...e })));
      set({
        clients: freshClients,
        events: freshEvents,
        selectedClient: null,
        demoMode: true,
        _realData: null,
      });
      get().showToast("Données démo réinitialisées", "info");
      get().persist?.();
    },

    toggleDemoMode: () => {
      const s = get();
      if (s.demoMode) {
        set({
          demoMode: false,
          _realData: { clients: s.clients, events: s.events },
          clients: [],
          events: [],
        });
      } else {
        const rd = s._realData || { clients: INIT_CLIENTS, events: INIT_EVENTS };
        const mergedClients = normalizeLegacyNoShowClients(
          mergePersistedClientsWithInit(rd.clients, INIT_CLIENTS)
        );
        const mergedEvents = normalizeLegacyNoShowEvents(mergePersistedEventsWithInit(rd.events, INIT_EVENTS));
        const t = s.sessionTarif || DEFAULT_TARIF;
        set({
          demoMode: true,
          clients: migrateAllClients(mergedClients, s.products, t),
          events: mergedEvents,
          _realData: null,
        });
      }
    },
  };
}
